import styled from 'styled-components';

export const StyledCurrencyText = styled.span`
  white-space: nowrap;
  font-family: ${(props) => (props.theme && props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'inherit'};
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyDisplay/components/CurrencyDisplayStyles.js